////////////For auth Action types //////////////////////////////////////
export const SET_AUTH = "set auth";
export const CLEAR_MAP_BUTTON_ACTIONS = "clear map actions boxes opened on map";